<template>
  <div class="content-item">
    <a-row>
      <a-col :span="24">
        <a class="open-instruction-video" href="#" @click.prevent="e => openInstructionVideo(introVideo)">
          <inline-svg :src="require('../../assets/images/video-capture.svg')" width="18" height="12" />
          <span>View instruction video again</span>
        </a>
      </a-col>
    </a-row>

    <a-row class="mt-3">
      <a-col :xs="{ span: 24, offset: 0 }" :sm="{ span: 20, offset: 2 }" :md="{ span: 16, offset: 4 }" :xl="{ span: 12, offset: 0 }">
        <h4 class="text-left pl-4" v-if="theme === 'dark'">1. Play video and pause where you want your screenshot</h4>
        <h4 class="text-left pl-4" v-else>1. Preview your {{ videoSubtitle }} and pause where you want the screenshot</h4>
        <div style="padding: 24px">
          <div class="responsive-embed">
            <video v-if="isRecorded" class="video-js" id="capturedVideo" controls preload="auto">
              <source :src="videoFileURL" type="video/webm" />
            </video>
            <div id="videoWrapper" style="background: black" v-else></div>
          </div>
        </div>
      </a-col>

      <a-col :xs="{ span: 24, offset: 0 }" :sm="{ span: 20, offset: 2 }" :md="{ span: 16, offset: 4 }" :xl="{ span: 12, offset: 0 }">
        <h4 class="text-left pl-4" v-if="theme === 'dark'">2. Click gold button to select your screenshot</h4>
        <h4 class="text-left pl-4" v-else>2. Click blue button to select your screenshot</h4>
        <a-row class="thumbnail-area">
          <a-col :span="24">
            <div class="responsive-embed">
              <canvas id="thumbnail" ref="thumbnail" width="1280" height="720"></canvas>
            </div>
          </a-col>
        </a-row>
        <a-row class="mt-1 mb-4">
          <a-col :span="12" class="w-full">
            <a-button type="primary" class="action-button take-thumbnail tf-btn tf-btn-primary" @click.prevent="onCapture">
              <span class="px-4">Create Screenshot</span>
            </a-button>
          </a-col>
        </a-row>
      </a-col>
    </a-row>

    <a-row>
      <h4 class="text-center my-3">3. Create your link to share on social media, text and email</h4>
      <a-col class="slug-input-wrapper" :xs="{ span: 24, offset: 0 }" :sm="{ span: 20, offset: 2 }" :md="{ span: 16, offset: 4 }" :xl="{ span: 12, offset: 6 }">
        <a-input
          :addon-before="urlPrefix"
          size="default"
          v-model="slug"
          pattern="^[a-z0-9]+(?:-[a-z0-9]+)*$"
          onkeypress="return event.charCode != 32"
          @keyup="onKeyUp"
          style="text-transform: lowercase"
          placeholder="Input your choice here"
        />
      </a-col>
    </a-row>
    <a-row class="mt-3 mb-4">
      <a-col :span="12" class="text-right" style="padding-right: 3rem">
        <a-popconfirm title="Are you sure？" ok-text="Yes" cancel-text="No" @confirm="onRedo()">
          <a-button type="primary" class="action-button tf-btn tf-btn-primary">
            <span>{{ $t('button.redoAll') }}</span>
          </a-button>
        </a-popconfirm>
      </a-col>
      <a-col :span="12" class="text-left" style="padding-left: 3rem">
        <a-button type="primary" class="action-button tf-btn tf-btn-primary" @click.prevent="onKeep">
          <span>{{ $t('button.keepAll') }}</span>
        </a-button>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { checkValidSlug } from '@/utils';
import Constants from '@/constants.js';
import 'context-filter-polyfill';
export default {
  props: {
    videoFile: {
      type: File,
    },
    type: {
      type: String,
      default: 'welcome',
    },
    videoSlug: {
      type: String,
    },
    language: {
      type: String,
    },
  },
  data() {
    return {
      slug: this.videoSlug,
      thumbnail: '',
    };
  },
  computed: {
    ...mapGetters(['theme']),
    urlPrefix() {
      if (this.language === 'es') {
        return `${Constants.APP_URL}/${this.language}/${this.type}`;
      } else {
        return `${Constants.APP_URL}/${this.type}`;
      }
    },
    isRecorded() {
      return this.videoFile && this.videoFile.name.endsWith('.mkv');
    },
    videoFileURL() {
      return URL.createObjectURL(this.videoFile);
    },
    videoSubtitle() {
      return this.type === 'welcome' ? 'welcome video' : 'Jesus Story';
    },
    introVideo() {
      const { configVars } = this.$store.state.settings;
      return this.type === 'welcome'
        ? configVars.WELCOME_INSTRUCTION_LINK || 'https://player.vimeo.com/video/8724775'
        : configVars.SHARE_STORY_INSTRUCTION_LINK || 'https://player.vimeo.com/video/444367865';
    },
  },
  methods: {
    ...mapActions({
      openInstructionVideo: 'openInstructionVideo',
    }),
    onRedo() {
      this.$emit('onRedo');
    },
    onKeep() {
      if (!this.slug) {
        this.$notification['warning']({
          message: 'Please enter the URL.',
        });

        return;
      } else if (!checkValidSlug(this.slug)) {
        this.$notification['warning']({
          message: 'You must only use lower case letters, no spaces or other characters are accepted.',
        });

        return;
      } else if (!this.thumbnail) {
        this.$notification['warning']({
          message: 'Please select the video thumbnail.',
        });

        return;
      }

      this.$emit('onExternalPreviewDone', this.slug, this.thumbnail);
    },
    onCapture() {
      let video = this.isRecorded ? document.querySelector('#capturedVideo') : document.querySelector('#videoWrapper').getElementsByTagName('video')[0];

      if (!video) {
        return;
      }

      if (video.currentTime === 0) {
        this.$notification['warning']({
          message: 'Play the video to select your screen shot.',
        });

        return;
      }
      const canvas = this.$refs.thumbnail;
      canvas.width = 640;
      canvas.height = 360;
      const ctx = canvas.getContext('2d');
      const cw = ctx.canvas.clientWidth;
      const ch = ctx.canvas.clientHeight;
      const vw = video.videoWidth;
      const vh = video.videoHeight;
      const r = 0;
      ctx.canvas.width = cw;
      ctx.canvas.height = ch;
      let rw = cw + 2 * r;
      let rh = (rw * vh) / vw;
      ctx.filter = 'blur(15px)';
      ctx.drawImage(video, 0, 0, vw, vh, -r, (ch - rh) / 2, rw, rh);

      const rate = vh / ch;
      rw = vw / rate;
      rh = vh / rate;
      const cx = (cw - rw) / 2;
      ctx.filter = 'blur(0px)';
      ctx.drawImage(video, 0, 0, vw, vh, cx, 0, rw, rh);
      this.thumbnail = canvas.toDataURL('image/png', 0.5);
    },
    onKeyUp(event) {
      this.slug = event.target.value.toLowerCase();
    },
  },
  mounted() {
    if (!this.isRecorded) {
      window.jwplayer('videoWrapper').setup({
        file: this.videoFileURL,
        primary: 'flash',
        type: 'mp4',
        autostart: false,
        repeat: false,
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.responsive-embed {
  background-color: transparent;
  box-shadow: none;
  border-radius: 0px;
  margin: 0 !important;
  padding-top: 0 !important;
}
.video-js {
  background-color: transparent !important;
  border-radius: 15px;
}

.thumbnail-area {
  min-height: 120px;
  padding: 24px;
}

canvas {
  border-radius: 15px;
  width: 100%;
  background: black;
}

.action-button.take-thumbnail {
  width: auto !important;
}

.w-full {
  width: 100%;
}

.open-instruction-video {
  display: flex;
  align-items: center;
  line-height: 16px;
  font-size: 14px;
  font-weight: 600;
  color: #637381;
  float: right;
  padding: 16px 0;
  text-decoration: none;

  & > span {
    margin-left: 8px;
  }
}

.slug-input-wrapper {
  font-size: 16px;
  display: flex;
  align-items: center;

  .slug-input-label {
    white-space: nowrap;
    flex: 0 0 auto;
    font-weight: 600;
  }

  .ant-input-group-wrapper {
    margin-left: 8px;
    flex: 1 1 auto;
  }
}

@media (max-width: 575px) {
  .slug-input-wrapper {
    flex-direction: column;
    align-items: start;

    .ant-input-group-wrapper {
      margin-left: 0;
    }
  }

  .thumbnail-area {
    margin-top: 16px;
    min-height: 0px;
  }
}

.action-button {
  width: 120px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
}
</style>

<style lang="scss">
.responsive-embed {
  & #videoWrapper {
    height: auto !important;
    border-radius: 15px !important;
    background: black;
  }
}
</style>
